import React, { useState, useEffect } from 'react'
import './AdminDashboard.css'
import ContentManagement from './ContentManagement'
import OrderManagement from './OrderManagement'
import Analytics from './Analytics'
import EcommerceSettings from './EcommerceSettings'
// import useApi from '../../../../utils/api-manager/Helper/useApi'
import { FaStore, FaShoppingCart, FaBox, FaDollarSign, FaCog, FaEdit, FaClipboardList, FaChartBar, FaWordpress } from 'react-icons/fa'

const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem('adminActiveTab') || 'analytics';
    });
    // const [orderStats, setOrderStats] = useState({ total: 0, pending: 0, completed: 0 })
    // const [loadingOrders, setLoadingOrders] = useState(true)
    // const { Get } = useApi()

    useEffect(() => {
        localStorage.setItem('adminActiveTab', activeTab);
    }, [activeTab]);

    // const stats = [
    //     { label: 'Total Sales', value: '₹1,24,500', icon: <FaDollarSign />, color: '#10b981' },
    //     { label: 'Total Orders', value: loadingOrders ? '...' : orderStats.total, icon: <FaShoppingCart />, color: '#3b82f6' },
    //     { label: 'Products', value: '89', icon: <FaBox />, color: '#f59e0b' },
    //     { label: 'Active Users', value: '1,234', icon: <FaStore />, color: '#8b5cf6' },
    // ]

    // useEffect(() => {
    //     const loadOrderStats = async () => {
    //         setLoadingOrders(true)
    //         try {
    //             const res = await Get('ordercards')
    //             const data = res.data || res
    //             setOrderStats({
    //                 total: Number(data.total_orders) || 0,
    //                 pending: Number(data.pending_orders) || 0,
    //                 completed: Number(data.completed_orders) || 0
    //             })
    //         } catch (error) {
    //             console.error('Error loading order stats:', error)
    //         } finally {
    //             setLoadingOrders(false)
    //         }
    //     }
    //     loadOrderStats()
    // }, [])

    return (
        <div className="responsive-box">
            <div className="admin-dashboard-container">
                <div className="header-section">
                    <h2>E-Commerce Controller</h2>
                </div>

                {/* Stats Cards - Commented Out */}
                {/* <div className="admin-stats-grid">
                    {stats.map((stat, idx) => (
                        <div key={idx} className="admin-stat-card">
                            <div className="stat-card-content">
                                <div className="stat-icon-wrapper" style={{ backgroundColor: `${stat.color}20`, color: stat.color }}>
                                    {stat.icon}
                                </div>
                                <div className="stat-info">
                                    <div className="stat-label">{stat.label}</div>
                                    <div className="stat-value-dash">{stat.value}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div> */}

                <div className="admin-tabs">
                    <button
                        className={`tab-btn ${activeTab === 'analytics' ? 'active' : ''}`}
                        onClick={() => setActiveTab('analytics')}
                    >
                        <FaChartBar /> Analytics
                    </button>
                    <button
                        className={`tab-btn ${activeTab === 'orders' ? 'active' : ''}`}
                        onClick={() => setActiveTab('orders')}
                    >
                        <FaClipboardList /> Orders
                    </button>
                    <button
                        className={`tab-btn ${activeTab === 'content' ? 'active' : ''}`}
                        onClick={() => setActiveTab('content')}
                    >
                        <FaEdit /> Content Manager
                    </button>
                    <button
                        className={`tab-btn ${activeTab === 'settings' ? 'active' : ''}`}
                        onClick={() => setActiveTab('settings')}
                    >
                        <FaCog /> Settings
                    </button>
                </div>

                <div className="admin-content">
                    {activeTab === 'analytics' && <Analytics />}

                    {activeTab === 'orders' && <OrderManagement />}

                    {activeTab === 'content' && <ContentManagement />}

                    {activeTab === 'settings' && <EcommerceSettings />}
                </div>
            </div>
        </div>
    )
}

export default AdminDashboard